//node_modules
import { useMemo } from "react";

//libs
import getPagingRange from "libs/helper/get-page-range";

//types
import type { PaginationState } from "./usePaginationHandler";

function usePaginationRange(handler: PaginationState<any>, maxButtons: number) {
  const page = handler.getPage();
  const pageCount = handler.getPageCount();
  return useMemo(() => getPagingRange(page, pageCount, maxButtons), [page, pageCount, maxButtons]);
}

export default usePaginationRange;
